import { useEffect } from 'react'
import { useSignupPageUpdate } from '@/services/onboardingService'
import { useReselector } from '@/utils/sharedHooks'
import { useAppDispatch } from '@/utils/typeHelpers'
import { useAnalyticsView } from '@/features/amplitude'
import { fetchAnnualTaxFilingsIfNeeded } from '@/featuresV1/Taxes/AnnualTaxes/annualTaxFilings.slice'
import { fetchAllAnnualTaxDetailsIfNeeded } from '@/featuresV1/Admin/AnnualTaxDetails/annualTaxDetails.slice'
import { selectAnnualTaxNotAvailable } from '@/featuresV1/Taxes/AnnualTaxes/annualTaxFilings.selector'
import { SIGNUP_PATHS } from '../helpers'
import { Disqualified } from './Disqualified'
import { ActiveTaxForm } from './ActiveTaxForm'

export const PreviousYearTaxForm = () => {
  const dispatch = useAppDispatch()
  const pageView = useAnalyticsView()

  const isNotAvailable = useReselector(selectAnnualTaxNotAvailable)

  useEffect(() => {
    dispatch(fetchAllAnnualTaxDetailsIfNeeded())
    dispatch(fetchAnnualTaxFilingsIfNeeded())
  }, [dispatch])

  useEffect(() => {
    pageView('previous year tax form')
  }, [pageView])

  useSignupPageUpdate(SIGNUP_PATHS.previousYearTax)

  if (isNotAvailable) {
    return <Disqualified />
  } else {
    return <ActiveTaxForm />
  }
}
